<template>
  <div>
    <div>
      <h3 class="title is-3">Quick Actions</h3>
      <div class="buttons">
        <router-link to="/feeds/new" el="button" class="button is-primary">Add Tournament</router-link>
        <router-link to="/articles/reimport" el="button" class="button is-primary">Reimport Article</router-link>
        <router-link to="/videos/reimport" el="button" class="button is-primary">Reimport Video</router-link>
        <router-link to="/pages/new" el="button" class="button is-primary">Add Page</router-link>
      </div>
    </div>

    <hr>

    <div v-if="counts">
      <h3 class="title is-3">Statistics</h3>
      <div class="tile is-ancestor">
        <router-link to="/topics" el="div" class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">{{counts.topics}}</p>
            <p class="subtitle">Topics</p>
          </article>
        </router-link>
        <router-link to="/feeds" el="div" class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">{{counts.feeds}}</p>
            <p class="subtitle">Feeds</p>
          </article>
        </router-link>
        <router-link to="/articles" el="div" class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">{{counts.articles}}</p>
            <p class="subtitle">Articles</p>
          </article>
        </router-link>
        <router-link to="/videos" el="div" class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">{{counts.videos}}</p>
            <p class="subtitle">Videos</p>
          </article>
        </router-link>
      </div>

      <div class="box">
        <div class="columns">
          <div class="column">
            <per-day-chart
              :data="counts.articles_per_date"
              color="rgba(0, 85, 165, 0.3)"
              title="Articles Created (7 Days)"
            ></per-day-chart>
          </div>
          <div class="column">
            <per-day-chart
              :data="counts.videos_per_date"
              color="rgba(255, 56, 58, 0.3)"
              title="Videos Created (7 Days)"
            ></per-day-chart>
          </div>
        </div>
      </div>
    </div>
    <loading v-else></loading>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import PerDayChart from "@/components/Per-Day-Chart";
import { GET_COUNTS } from "@/store/actions";

export default {
  name: "home",
  components: {
    Loading,
    PerDayChart
  },
  computed: {
    counts() {
      return this.$store.state.home.data;
    }
  },
  mounted() {
    if (!this.counts) {
      this.$store.dispatch(GET_COUNTS);
    }
  }
};
</script>
